function sendClickYM(params) {
    ym(30772883, 'params', params);
}

function sendFormYM(form, params) {
    ym(30772883, 'reachGoal', form, params);
}

window.sendClickYM = sendClickYM;
window.sendFormYM = sendFormYM;
window.pagePath = window.location.pathname;

window.pageType = (function (path) {
    if (path === "/") return "main";
    if (path.includes("shiny")) return "tire_catalog";
    if (path.includes("diski")) return "disk_catalog";
    if (path.includes("portfolio")) return "portfolio_catalog";
    if (path.includes("aksessuary")) return "aksessuary_catalog";
    return "other";
  })(window.location.pathname);
